import { Method } from "../Config";
import { ResponseType, Gateway } from "./Gateway";

interface FindPasswordParams {
    address: string;
    host: string;
}

interface FAQMailQueryParams {
    name: string;
    email: string;
    title: string;
    url?: string;
    desc: string;
}

/**
 * @author Kim Young Jun
 * @date 2025-03-25
 * @remark 메일링 Gateway
 */

class MailingGateway extends Gateway {
    protected readonly _contextPath = "mail";
    protected readonly _pathParams?: { [key: string]: string };
    protected readonly _processParams = {
        find: "find",
        faq: "faq",
    };

    // GET
    public async reqSendFindPassword(param: FindPasswordParams): Promise<ResponseType> {
        const queryParam = {
            process: this._processParams.find,
            ...param,
        };

        return await this.request(Method.GET, undefined, queryParam);
    }

    public async reqSendQuestion(param: FAQMailQueryParams): Promise<ResponseType> {
        const queryParam = {
            process: this._processParams.faq,
            ...param,
        };

        return await this.request(Method.GET, undefined, queryParam);
    }
}

export { MailingGateway, type FindPasswordParams, type FAQMailQueryParams };
